import { BoxProps } from "@mui/system"
import React from "react"

import { Button, Typography } from "src/UILibrary"

type Prop = {
  sx?: BoxProps
  className?: string
  caption: string
  onClick?: any
  fontColor?: string
  fontWeight?: string
  fontSize?: number
}

export const OutlinedButton = ({
  sx,
  className,
  caption,
  onClick,
  fontColor,
  fontWeight,
  fontSize,
}: Prop) => {
  const style = sx || {}

  return (
    <Button
      variant="outlined"
      className={className}
      sx={{
        p: "10px",
        width: 240,
        fontSize: 16,
        borderRadius: 0,
        ...style,
      }}
      color="secondary"
      onClick={() => onClick()}
    >
      <Typography.DetailText
        sx={fontColor ? { color: fontColor } : {}}
        fontWeight={[fontWeight]}
        fontSize={fontSize}
      >
        {caption}
      </Typography.DetailText>
    </Button>
  )
}
